import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import HeaderBox from './header-box'
import { getCurrentQueueStatus } from 'modules/queues/selectors'


const QueueStatus = ({ queueStatus }) => {
  const statusValue = queueStatus && typeof queueStatus.status === 'string' ?
    queueStatus.status
    : 'NOT STARTED';

  return <HeaderBox header="Status" value={ <span className="h4">{ statusValue }</span> } />
};

QueueStatus.propTypes = {
  queueStatus: PropTypes.shape({
    status: PropTypes.string.isRequired,
  }),
};

const mapStateToProps = createStructuredSelector({
  queueStatus: getCurrentQueueStatus,
});

export default connect(mapStateToProps)(QueueStatus)



// WEBPACK FOOTER //
// ./src/components/links/header/queue-status.js